import ListFilter from "assets/svgs/list_filter/ListFilter";
import React, { useState } from "react";
import { Button, Col, Dropdown, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

function OrderFilter({ setActionableFilter }) {
  const [filterArray, setFilterArray] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const filters = [
    "delivered",
    "ghost",
    "in_progress",
    "pending",
    "pending_prescription",
    "shipped",
    "shipping_pending",
    "unknown",
    "void",
  ];

  const handleReset = () => {
    setFilterArray([]);
    setActionableFilter([]);
    setDropdownOpen(false);
  };

  const handleCheckboxClick = (filter) => {
    if (filterArray.includes(filter)) {
      setFilterArray(filterArray.filter((item) => item !== filter));
    } else {
      setFilterArray([...filterArray, filter]);
    }
  };

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleOKClick = () => {
    setActionableFilter(filterArray);
    setDropdownOpen(false);
  };

  return (
    <Col className="flex-1">
      <div className="d-flex justify-content-between">
        <Dropdown onToggle={handleDropdownToggle} show={dropdownOpen}>
          <Dropdown.Toggle
            className="pe-0 ps-2 nav-link"
            onClick={handleDropdownToggle}
          >
            <ListFilter />
          </Dropdown.Toggle>

          <Dropdown.Menu className=" dropdown-menu-card dropdown-menu-end">
            <Form
              style={{ width: "12rem" }}
              className="bg-white rounded-2 py-2 mx-2 d-flex flex-column align-items-center"
            >
              {filters.map((filter) => (
                <Form.Check
                  key={filter}
                  type="checkbox"
                  className="mx-2 pe-2 text-black w-100"
                  checked={filterArray.includes(filter)}
                  onClick={() => handleCheckboxClick(filter)}
                  id={filter.toUpperCase().replace("_", " ")}
                  label={filter.toUpperCase().replace("_", " ")}
                />
              ))}
              <div className="d-flex justify-content-between w-100">
                <Button size="sm" variant="secondary" onClick={handleReset}>
                  Reset
                </Button>
                <Button size="sm" onClick={handleOKClick}>
                  OK
                </Button>
              </div>
            </Form>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </Col>
  );
}

export default OrderFilter;
